import { useQueryPhonesByCountry } from '../queries/customerSupport/hooks/useQueryPhonesByCountry';

export const useCustomerSupportPhone = (countryCode: string) => {
  const { data: phonesByCountryData, loading } = useQueryPhonesByCountry({
    variables: {
      params: {
        ...(countryCode && { countryCode }),
        contactType: 'TRAVELLER',
      },
    },
  });

  return {
    customerSupportPhone: phonesByCountryData?.phonesByCountry[0]?.phoneNumber,
    loading,
  };
};
